<template>
    <div>
        <b-container class="detalle-noticia">
            <b-row>
                <!-- el detalle de la noticia -->
                <b-col cols="12" md="8">
                    <Noticia
                        :idNoticia="noticia.id_noticia"
                        :titulo="noticia.noticia"
                        :descripcion="noticia.contenido"
                        :imagen="noticia.imagen"
                        botonDetalle='N'
                        botonRegresar='S'
                    />
                </b-col>
                <b-col cols="12" md="4">
                    <div>
                        <h4>Noticias recientes</h4>
                        <b-container>
                            <MiniNoticia v-for="reciente in noticiasRecientes" :key="reciente.id_noticia"
                                :idNoticia="reciente.id_noticia"
                                :fecha="reciente.ffeccap"
                                :titulo="reciente.noticia"
                                :imagen="reciente.imagen"
                            />
                        </b-container>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import Noticia from '@/components/Noticia.vue'
import MiniNoticia from '@/components/MiniNoticia.vue'
import axios from 'axios'
import {mapState} from 'vuex'

export default {
    name: 'DetalleNoticia',
    components: {
        Noticia, MiniNoticia
    },
    props: {
    },
    data() {
        return {
            noticia: {},
            noticiasRecientes: []
        }
    },
    created() {
        this.traerNoticia()
        this.traerRecientes()
    },
    watch: {
        $route(nuevaRuta) {
            this.traerNoticia()
        }
    },
    methods: {
        zfill(number, width) {
            var numberOutput = Math.abs(number); /* Valor absoluto del número */
            var length = number.toString().length; /* Largo del número */ 
            var zero = "0"; /* String de cero */  
            
            if (width <= length) {
                if (number < 0) {
                    return ("-" + numberOutput.toString()); 
                } else {
                    return numberOutput.toString(); 
                }
            } else {
                if (number < 0) {
                    return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
                } else {
                    return ((zero.repeat(width - length)) + numberOutput.toString()); 
                }
            }
        },
        traerNoticia() {
            var idNoticia = this.$route.params.id
            var formData = new FormData();
            formData.append("accion", "mostrarDatos");
            formData.append("tabla", "vnoticias");
            formData.append("filtro", `id_noticia=${idNoticia}`);
            formData.append("limite", 1);
            
            axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
            .then((res) => {
                this.noticia = res.data

                this.incrementaContador()
            });
        },
        incrementaContador() {
            var formData = new FormData();

            formData.append("accion", "incrementaContador");
            formData.append("idNoticia", this.noticia.id_noticia);
            
            axios.post(`${this.url}/ajax/ajax.noticias.php`, formData)
        },
        traerRecientes() {
            var formData = new FormData();
            formData.append("accion", "mostrarDatos");
            formData.append("tabla", "vnoticias");
            formData.append("filtro", `vigencia >=${this.hoy}`);
            formData.append("ordenamiento", `id_noticia desc`);
            formData.append("limite", 5);
            
            axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
            .then((res) => {
                this.noticiasRecientes = res.data
            });
        }
    },
    computed: {
        hoy() {
            var fecha = new Date();
            var dia = fecha.getDate();

            var mes = fecha.getMonth();
            mes ++;
            
            var anio = fecha.getFullYear();
            
            return anio + '-' + this.zfill(mes, 2) + '-' + this.zfill(dia, 2);
        },
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox'])
    }
}
</script>


<style scoped>
.detalle-noticia {
  margin-top: 90px;
}

</style>